import script from "./UserDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailDialog.vue?vue&type=style&index=0&id=10dbc19a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10dbc19a"]])

export default __exports__